/**
 * Premium header — scroll state for glass nav & homepage overlay
 */
(function () {
  'use strict';

  var SCROLL_THRESHOLD = 20;

  function updateHeader() {
    var header = document.getElementById('header-component');
    if (!header) return;

    var scrolled = window.scrollY > SCROLL_THRESHOLD;
    header.classList.toggle('header--scrolled', scrolled);

    if (document.body.classList.contains('template-index')) {
      header.classList.toggle('header--over-hero', !scrolled);
    }
  }

  function onScroll() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      updateHeader();
      return;
    }
    window.requestAnimationFrame(updateHeader);
  }

  function init() {
    updateHeader();
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('shopify:section:load', updateHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
